import axios from 'axios';

export const apiEmpresa = axios.create({
  baseURL: `${process.env.REACT_APP_BASE_URL}/api4/empresa`,
  
})
